module.exports = __webpack_public_path__ + "img/panelView_strong_2_1.89431a6e.png";